import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import { formatNumber } from "../../utils/helpers";

const OrderTable = ({
  orders,
  page,
  rowsPerPage,
  totalOrders,
  setPage,
  setRowsPerPage,
  handleCancelOrder,
  handleDeleteOrder,
  handleShowInvoiceModal,
  hasPermission,
}) => {
  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Mã Đơn hàng</TableCell>
              <TableCell>Sản phẩm (SL)</TableCell>
              <TableCell>Tổng số tiền</TableCell>
              <TableCell>Đã thanh toán</TableCell>
              <TableCell>Thanh toán</TableCell>
              <TableCell>Ngày tạo đơn</TableCell>
              <TableCell>Hành động</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((order) => (
              <TableRow key={order._id}>
                <TableCell>
                  {order.orderCode}
                  {order.status === "Cancelled" && (
                    <Typography
                      variant="body2"
                      color="error"
                      fontWeight={600}
                    >
                      Đã hủy
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  {order.items.map((item) => (
                    <div key={item._id}>
                      {item?.product?.name} (SL: {item?.quantity})
                    </div>
                  ))}
                </TableCell>
                <TableCell>{formatNumber(order.totalAmount)}</TableCell>
                <TableCell>{formatNumber(order.amountPaid)}</TableCell>
                <TableCell>
                  {order.paymentMethod === "Cash" ? "Tiền mặt" : "Chuyển khoản"}
                </TableCell>
                <TableCell>
                  {new Date(order.createdAt).toLocaleTimeString("vi-VN", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  }) +
                    " " +
                    new Date(order.createdAt).toLocaleDateString("vi-VN")}
                </TableCell>
                <TableCell>
                  {hasPermission(["order:update"]) && (
                    <IconButton
                      onClick={() => handleCancelOrder(order)}
                      color="warning"
                      disabled={order.status === "Cancelled"}
                    >
                      <CancelIcon />
                    </IconButton>
                  )}
                  {hasPermission(["order:delete"]) && (
                    <IconButton
                      onClick={() => handleDeleteOrder(order)}
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                  <IconButton
                    onClick={() => handleShowInvoiceModal(order)}
                    color="info"
                  >
                    <PrintIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalOrders}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
      />
    </>
  );
};

export default OrderTable;
